const 韻鏡資料 = `蓬1,1,3
蒙1,1,4
東1,1,5
通1,1,6
同1,1,7
公1,1,9
空1,1,10
㟅1,1,12
葼1,1,13
悤1,1,14
叢1,1,15
𣞷1,1,16
翁1,1,18
烘1,1,19
洪1,1,20
籠1,1,22
崇1,2,15
風1,3,1
豐1,3,2
馮1,3,3
瞢1,3,4
中1,3,5
忡1,3,6
蟲1,3,7
弓1,3,9
穹1,3,10
窮1,3,11
𧲤1,3,12
終1,3,13
充1,3,14
雄1,3,20
肜1,3,21
隆1,3,22
戎1,3,23
嵩1,4,16
融1,4,21
琫1,5,1
菶1,5,3
蠓1,5,4
董1,5,5
桶1,5,6
動1,5,7
𨑊1,5,8
孔1,5,10
總1,5,13
㪌1,5,16
蓊1,5,18
嗊1,5,19
𢦅1,5,20
䏊1,5,22
摓1,9,3
夢1,9,4
凍1,9,5
痛1,9,6
洞1,9,7
齈1,9,8
貢1,9,9
控1,9,10
糉1,9,13
謥1,9,14
𣀒1,9,15
送1,9,16
甕1,9,18
烘1,9,19
閧1,9,20
弄1,9,22
㓽1,10,15
諷1,11,1
賵1,11,2
鳳1,11,3
𢄐1,11,4
中1,11,5
仲1,11,7
焪1,11,10
眾1,11,13
銃1,11,14
𧽒1,11,19
趥1,12,14
卜1,13,1
扑1,13,2
暴1,13,3
木1,13,4
豰1,13,5
禿1,13,6
獨1,13,7
穀1,13,9
哭1,13,10
鏃1,13,13
瘯1,13,14
族1,13,15
速1,13,16
屋1,13,18
熇1,13,19
縠1,13,20
祿1,13,22
縬1,14,13
珿1,14,14
縮1,14,16
福1,15,1
蝮1,15,2
伏1,15,3
目1,15,4
竹1,15,5
蓄1,15,6
逐1,15,7
朒1,15,8
菊1,15,9
麴1,15,10
驧1,15,11
砡1,15,12
粥1,15,13
俶1,15,14
叔1,15,16
塾1,15,17
郁1,15,18
畜1,15,19
囿1,15,21
六1,15,22
肉1,15,23
蹙1,16,13
鼀1,16,14
𣤶1,16,15
肅1,16,16
育1,16,21
冬2,1,5
炵2,1,6
彤2,1,7
農2,1,8
攻2,1,9
宗2,1,13
驄2,1,14
賨2,1,15
鬆2,1,16
䃔2,1,20
䃧2,1,22
封2,3,1
峯2,3,2
逢2,3,3
傭2,3,6
重2,3,7
醲2,3,8
恭2,3,9
銎2,3,10
蛩2,3,11
顒2,3,12
鍾2,3,13
𧘂2,3,14
舂2,3,16
鱅2,3,17
邕2,3,18
匈2,3,19
容2,3,21
龍2,3,22
茸2,3,23
縱2,4,13
樅2,4,14
從2,4,15
淞2,4,16
松2,4,17
庸2,4,21
覂2,7,1
捧2,7,2
奉2,7,3
冢2,7,5
寵2,7,6
重2,7,7
拱2,7,9
恐2,7,10
拲2,7,11
腫2,7,13
𨿿2,7,14
尰2,7,17
擁2,7,18
隴2,7,22
宂2,7,23
䙕2,8,13
𢛒2,8,14
悚2,8,16
甬2,8,21
雺2,9,4
湩2,9,5
統2,9,6
綜2,9,13
宋2,9,16
䃔2,9,20
葑2,11,1
俸2,11,3
蹱2,11,6
重2,11,7
𢫨2,11,8
供2,11,9
恐2,11,10
共2,11,11
種2,11,13
贚2,11,22
䩸2,11,23
縱2,12,13
從2,12,15
頌2,12,17
用2,12,21
襮2,13,1
蓴2,13,2
僕2,13,3
瑁2,13,4
篤2,13,5
毒2,13,7
褥2,13,8
梏2,13,9
酷2,13,10
𤛹2,13,12
傶2,13,13
洬2,13,16
沃2,13,18
熇2,13,19
鵠2,13,20
濼2,13,22
㑛2,14,14
𤉐2,14,15
䪁2,15,1
幞2,15,3
媦2,15,4
瘃2,15,5
躅2,15,7
輂2,15,9
曲2,15,10
局2,15,11
玉2,15,12
燭2,15,13
觸2,15,14
贖2,15,15
束2,15,16
蜀2,15,17
郁2,15,18
旭2,15,19
欲2,15,21
錄2,15,22
辱2,15,23
足2,16,13
促2,16,14
粟2,16,16
續2,16,17
邦3,2,1
胮3,2,2
龐3,2,3
厖3,2,4
樁3,2,5
憃3,2,6
幢3,2,7
𦗳3,2,8
江3,2,9
腔3,2,10
㟅3,2,12
牕3,2,14
淙3,2,15
雙3,2,16
胦3,2,18
舡3,2,19
降3,2,20
瀧3,2,22
𦂌3,6,1
㭋3,6,3
𠈵3,6,4
講3,6,9
慃3,6,18
傋3,6,19
項3,6,20
肨3,10,2
䏵3,10,4
戇3,10,5
𥈄3,10,6
䡴3,10,7
絳3,10,9
䎫3,10,14
漴3,10,15
淙3,10,16
巷3,10,20
剝3,14,1
璞3,14,2
雹3,14,3
邈3,14,4
斲3,14,5
逴3,14,6
濁3,14,7
搦3,14,8
覺3,14,9
㱿3,14,10
岳3,14,12
捉3,14,13
娖3,14,14
浞3,14,15
朔3,14,16
渥3,14,18
學3,14,20
犖3,14,22
齜4,2,13
差4,2,14
齹4,2,15
釃4,2,16
陂4,3,1
鈹4,3,2
皮4,3,3
縻4,3,4
知4,3,5
摛4,3,6
馳4,3,7
羈4,3,9
㩻4,3,10
奇4,3,11
宜4,3,12
支4,3,13
眵4,3,14
疵4,3,15
施4,3,16
匙4,3,17
猗4,3,18
犧4,3,19
離4,3,22
兒4,3,23
卑4,4,1
披4,4,2
陴4,4,3
彌4,4,4
祇4,4,11
貲4,4,13
雌4,4,14
斯4,4,16
移4,4,21
㧗4,6,13
躧4,6,16
彼4,7,1
㱟4,7,2
被4,7,3
靡4,7,4
㨖4,7,5
褫4,7,6
豸4,7,7
抳4,7,8
掎4,7,9
綺4,7,10
技4,7,11
螘4,7,12
紙4,7,13
侈4,7,14
舐4,7,15
弛4,7,16
氏4,7,17
倚4,7,18
邐4,7,22
爾4,7,23
俾4,8,1
諀4,8,2
婢4,8,3
弭4,8,4
踦4,8,9
企4,8,10
紫4,8,13
此4,8,14
徙4,8,16
酏4,8,21
柴4,10,13
屣4,10,16
賁4,11,1
帔4,11,2
髲4,11,3
智4,11,5
寄4,11,9
㞆4,11,10
芰4,11,11
義4,11,12
寘4,11,13
卶4,11,14
翅4,11,16
豉4,11,17
倚4,11,18
戲4,11,19
詈4,11,22
馶4,12,9
企4,12,10
積4,12,13
刺4,12,14
漬4,12,15
賜4,12,16
易4,12,21
腄5,3,5
鬌5,3,7
嬀5,3,9
虧5,3,10
䞚5,3,11
危5,3,12
䮔5,3,13
吹5,3,14
垂5,3,17
逶5,3,18
麾5,3,19
爲5,3,21
羸5,3,22
痿5,3,23
錘5,4,7
規5,4,9
闚5,4,10
劑5,4,13
眭5,4,16
隨5,4,17
隳5,4,19
蠵5,4,21
詭5,7,9
跪5,7,11
硊5,7,12
捶5,7,13
揣5,7,14
菙5,7,17
委5,7,18
毀5,7,19
蔿5,7,21
累5,7,22
蘂5,7,23
跬5,8,10
觜5,8,13
惢5,8,15
髓5,8,16
𣿂5,8,17
䓈5,8,21
娷5,11,5
縋5,11,7
諉5,11,8
䞈5,11,9
僞5,11,12
惴5,11,13
吹5,11,14
睡5,11,17
餧5,11,18
毀5,11,19
爲5,11,21
累5,11,22
䄲5,11,23
瞡5,12,9
觖5,12,10
䅗5,12,16
恚5,12,18
孈5,12,19
瓗5,12,21
師6,2,16
悲6,3,1
丕6,3,2
邳6,3,3
眉6,3,4
胝6,3,5
絺6,3,6
墀6,3,7
尼6,3,8
飢6,3,9
耆6,3,11
狋6,3,12
脂6,3,13
鴟6,3,14
尸6,3,16
棃6,3,22
紕6,4,2
毗6,4,3
咨6,4,13
郪6,4,14
茨6,4,15
私6,4,16
伊6,4,18
夷6,4,19
姨6,4,21
鄙6,7,1
嚭6,7,2
否6,7,3
美6,7,4
黹6,7,5
𡳭6,7,6
雉6,7,7
秜6,7,8
几6,7,9
跽6,7,11
旨6,7,13
矢6,7,16
視6,7,17
㰻6,7,18
履6,7,22
匕6,8,1
牝6,8,3
姊6,8,13
死6,8,16
兕6,8,17
祕6,11,1
濞6,11,2
備6,11,3
郿6,11,4
致6,11,5
緻6,11,7
膩6,11,8
冀6,11,9
器6,11,10
臮6,11,11
劓6,11,12
至6,11,13
痓6,11,14
示6,11,15
屍6,11,16
嗜6,11,17
懿6,11,18
齂6,11,19
利6,11,22
二6,11,23
痹6,12,1
屁6,12,2
鼻6,12,3
寐6,12,4
地6,12,7
弃6,12,10
恣6,12,13
次6,12,14
自6,12,15
四6,12,16
呬6,12,19
系6,12,20
肄6,12,21
衰7,2,16
追7,3,5
鎚7,3,7
龜7,3,9
巋7,3,10
逵7,3,11
錐7,3,13
推7,3,14
誰7,3,17
㶟7,3,22
蕤7,3,23
葵7,4,11
嗺7,4,13
綏7,4,16
惟7,4,21
軌7,7,9
巋7,7,10
䣀7,7,11
沝7,7,13
水7,7,16
𦗑7,7,19
洧7,7,21
壘7,7,22
蕊7,7,23
癸7,8,9
揆7,8,11
濢7,8,13
趡7,8,14
㠑7,8,15
唯7,8,21
轛7,11,5
墜7,11,7
媿7,11,9
喟7,11,10
匱7,11,11
出7,11,14
㽷7,11,16
位7,11,21
類7,11,22
季7,12,9
悸7,12,11
醉7,12,13
翠7,12,14
萃7,12,15
邃7,12,16
遂7,12,17
侐7,12,19
遺7,12,21
菑8,2,13
茬8,2,15
癡8,3,6
治8,3,7
姬8,3,9
欺8,3,10
其8,3,11
疑8,3,12
之8,3,13
蚩8,3,14
詩8,3,16
時8,3,17
醫8,3,18
僖8,3,19
釐8,3,22
而8,3,23
抾8,4,10
兹8,4,13
慈8,4,15
思8,4,16
詞8,4,17
飴8,4,21
滓8,6,13
㓼8,6,14
士8,6,15
史8,6,16
俟8,6,17
徵8,7,5
恥8,7,6
峙8,7,7
伱8,7,8
紀8,7,9
起8,7,10
擬8,7,12
止8,7,13
齒8,7,14
始8,7,16
市8,7,17
譩8,7,18
喜8,7,19
以8,7,21
里8,7,22
耳8,7,23
子8,8,13
枲8,8,16
似8,8,17
胾8,10,13
廁8,10,14
事8,10,15
駛8,10,16
置8,11,5
眙8,11,6
值8,11,7
記8,11,9
亟8,11,10
忌8,11,11
䰯8,11,12
志8,11,13
熾8,11,14
試8,11,16
侍8,11,17
意8,11,18
憙8,11,19
吏8,11,22
餌8,11,23
恣8,12,13
蛓8,12,14
字8,12,15
笥8,12,16
寺8,12,17
異8,12,21
機9,3,9
祈9,3,11
沂9,3,12
依9,3,18
希9,3,19
蟣9,7,9
豈9,7,10
顗9,7,12
扆9,7,18
豨9,7,19
既9,11,9
氣9,11,10
䤒9,11,11
毅9,11,12
欷9,11,19
廢9,15,1
計9,15,9
刈9,15,12
非10,3,1
菲10,3,2
肥10,3,3
微10,3,4
歸10,3,9
蘬10,3,10
頎10,3,11
巍10,3,12
威10,3,18
韋10,3,21
匪10,7,1
斐10,7,2
膹10,7,3
尾10,7,4
鬼10,7,9
磈10,7,18
虺10,7,19
韙10,7,21
沸10,11,1
費10,11,2
痱10,11,3
未10,11,4
貴10,11,9
𥽂10,11,10
鞼10,11,11
魏10,11,12
尉10,11,18
諱10,11,19
胃10,11,21
廢10,15,1
吠10,15,3
𥏙10,15,10
𤜂10,15,11
䂕10,15,12
穢10,15,18
喙10,15,19
𦵔11,2,13
初11,2,14
鉏11,2,15
疎11,2,16
豬11,3,5
攄11,3,6
除11,3,7
袽11,3,8
居11,3,9
墟11,3,10
渠11,3,11
魚11,3,12
諸11,3,13
書11,3,16
蜍11,3,17
於11,3,18
虛11,3,19
余11,3,21
臚11,3,22
如11,3,23
苴11,4,13
疽11,4,14
胥11,4,16
徐11,4,17
阻11,6,13
楚11,6,14
齟11,6,15
所11,6,16
貯11,7,5
禇11,7,6
佇11,7,7
女11,7,8
舉11,7,9
去11,7,10
巨11,7,11
語11,7,12
䰞11,7,13
杵11,7,14
紓11,7,15
暑11,7,16
野11,7,17
𢮁11,7,18
許11,7,19
吕11,7,22
汝11,7,23
苴11,8,13
𤿚11,8,14
咀11,8,15
諝11,8,16
敘11,8,17
與11,8,21
詛11,10,13
儊11,10,14
助11,10,15
疏11,10,16
著11,11,5
絮11,11,6
箸11,11,7
女11,11,8
據11,11,9
去11,11,10
遽11,11,11
御11,11,12
翥11,11,13
處11,11,14
恕11,11,16
署11,11,17
飫11,11,18
噓11,11,19
慮11,11,22
洳11,11,23
怚11,12,13
覷11,12,14
絮11,12,16
屐11,12,17
豫11,12,21
逋12,1,1
鋪12,1,2
蒲12,1,3
模12,1,4
都12,1,5
㻌12,1,6
徒12,1,7
奴12,1,8
孤12,1,9
枯12,1,10
吾12,1,12
租12,1,13
麤12,1,14
徂12,1,15
蘓12,1,16
烏12,1,18
呼12,1,19
胡12,1,20
盧12,1,22
㑳12,2,13
芻12,2,14
雛12,2,15
毹12,2,16
膚12,3,1
敷12,3,2
符12,3,3
無12,3,4
株12,3,5
貙12,3,6
廚12,3,7
拘12,3,9
區12,3,10
劬12,3,11
虞12,3,12
朱12,3,13
樞12,3,14
輸12,3,16
殊12,3,17
紆12,3,18
訏12,3,19
于12,3,21
慺12,3,22
儒12,3,23
諏12,4,13
趨12,4,14
須12,4,16
逾12,4,21
補12,5,1
普12,5,2
簿12,5,3
姥12,5,4
覩12,5,5
土12,5,6
杜12,5,7
努12,5,8
古12,5,9
苦12,5,10
五12,5,12
祖12,5,13
蔖12,5,14
粗12,5,15
隖12,5,18
虎12,5,19
戶12,5,20
魯12,5,22
䝒12,6,15
數12,6,16
甫12,7,1
撫12,7,2
父12,7,3
武12,7,4
拄12,7,5
柱12,7,7
矩12,7,9
齲12,7,10
寠12,7,11
麌12,7,12
主12,7,13
豎12,7,17
傴12,7,18
詡12,7,19
羽12,7,21
縷12,7,22
乳12,7,23
取12,8,14
聚12,8,15
𦄼12,8,16
庾12,8,21
布12,9,1
怖12,9,2
捕12,9,3
暮12,9,4
妬12,9,5
菟12,9,6
渡12,9,7
笯12,9,8
顧12,9,9
絝12,9,10
誤12,9,12
做12,9,13
庴12,9,14
祚12,9,15
訴12,9,16
汙12,9,18
謼12,9,19
護12,9,20
路12,9,22
菆12,10,14
捒12,10,16
付12,11,1
赴12,11,2
附12,11,3
務12,11,4
註12,11,5
𨳳12,11,6
住12,11,7
驅12,11,10
懼12,11,11
遇12,11,12
注12,11,13
戍12,11,16
樹12,11,17
嫗12,11,18
呴12,11,19
芋12,11,21
屢12,11,22
孺12,11,23
緅12,12,13
娶12,12,14
聚12,12,15
尠12,12,16
裕12,12,21
𡜊13,1,2
𤗏13,1,3
𪒴13,1,5
胎13,1,6
臺13,1,7
能13,1,8
該13,1,9
開13,1,10
皚13,1,12
哉13,1,13
猜13,1,14
裁13,1,15
鰓13,1,16
哀13,1,18
咍13,1,19
來13,1,22
排13,2,3
埋13,2,4
𪘨13,2,5
搋13,2,6
搱13,2,8
皆13,2,9
揩13,2,10
𩂢13,2,12
齋13,2,13
差13,2,14
豺13,2,15
崽13,2,16
𢰇13,2,18
𢓬13,2,19
諧13,2,20
唻13,2,22
㹗13,3,14
篦13,4,1
批13,4,2
鼙13,4,3
迷13,4,4
氐13,4,5
梯13,4,6
題13,4,7
泥13,4,8
雞13,4,9
谿13,4,10
倪13,4,12
齎13,4,13
妻13,4,14
齊13,4,15
西13,4,16
鷖13,4,18
醯13,4,19
兮13,4,20
黎13,4,22
臡13,4,23
俖13,5,1
啡13,5,2
蓓13,5,3
䆀13,5,4
等13,5,5
㘆13,5,6
駘13,5,7
乃13,5,8
改13,5,9
愷13,5,10
宰13,5,13
采13,5,14
在13,5,15
欸13,5,18
海13,5,19
亥13,5,20
佁13,5,21
𨦂13,5,22
疓13,5,23
矲13,6,3
鍇13,6,9
楷13,6,10
騃13,6,12
駭13,6,20
獺13,6,22
茝13,7,14
灑13,7,17
㪏13,8,1
䫌13,8,2
陛13,8,3
米13,8,4
邸13,8,5
體13,8,6
弟13,8,7
禰13,8,8
啓13,8,10
掜13,8,12
濟13,8,13
泚13,8,14
薺13,8,15
洗13,8,16
𠯋13,8,18
徯13,8,20
禮13,8,22
𢘥13,9,2
䆀13,9,4
戴13,9,5
貸13,9,6
代13,9,7
耐13,9,8
溉13,9,9
慨13,9,10
隑13,9,11
礙13,9,12
載13,9,13
菜13,9,14
載13,9,15
賽13,9,16
愛13,9,18
儗13,9,19
瀣13,9,20
賚13,9,22
拜13,10,1
褹13,10,8
誡13,10,9
烗13,10,10
𦗐13,10,12
瘵13,10,13
瘥13,10,14
噫13,10,18
譮13,10,19
械13,10,20
㿃13,11,5
跇13,11,6
滯13,11,7
猘13,11,9
憩13,11,10
偈13,11,11
㓷13,11,12
制13,11,13
掣13,11,14
丗13,11,16
逝13,11,17
䋵13,11,19
例13,11,22
閉13,12,1
媲13,12,2
薜13,12,3
謎13,12,4
帝13,12,5
替13,12,6
第13,12,7
泥13,12,8
計13,12,9
契13,12,10
詣13,12,12
霽13,12,13
砌13,12,14
嚌13,12,15
細13,12,16
翳13,12,18
蒵13,12,20
麗13,12,22
𦽳13,14,6
𦤧13,14,7
犗13,14,9
啐13,14,14
寨13,14,15
𠱡13,14,16
喝13,14,18
䜕13,14,19
㕢13,14,20
杯14,1,1
肧14,1,2
裴14,1,3
枚14,1,4
磓14,1,5
𨌴14,1,6
頹14,1,7
㮃14,1,8
傀14,1,9
恢14,1,10
鮠14,1,12
嗺14,1,13
崔14,1,14
摧14,1,15
𤗯14,1,16
隈14,1,18
灰14,1,19
回14,1,20
雷14,1,22
尵14,2,7
乖14,2,9
匯14,2,10
膗14,2,15
虺14,2,19
懷14,2,20
䐯14,2,22
圭14,4,9
睽14,4,10
烓14,4,18
睳14,4,19
攜14,4,20
琲14,5,3
浼14,5,4
𦞙14,5,5
骽14,5,6
鐓14,5,7
餧14,5,8
䫥14,5,10
頠14,5,12
嶊14,5,13
皠14,5,14
罪14,5,15
猥14,5,18
賄14,5,19
瘣14,5,20
倄14,5,21
礧14,5,22
𩬳14,6,5
背14,9,1
配14,9,2
佩14,9,3
妹14,9,4
對14,9,5
退14,9,6
隊14,9,7
內14,9,8
憒14,9,9
塊14,9,10
鞼14,9,11
磑14,9,12
晬14,9,13
倅14,9,14
碎14,9,16
𩲄14,9,18
誨14,9,19
潰14,9,20
纇14,9,22
拜14,10,1
湃14,10,2
憊14,10,3
䀛14,10,4
怪14,10,9
蒯14,10,10
聵14,10,12
𧱳14,10,19
壞14,10,20
綴14,11,5
劌14,11,9
𥏙14,11,10
贅14,11,13
毳14,11,14
稅14,11,16
衛14,11,21
芮14,11,23
桂14,12,9
嘒14,12,19
慧14,12,20
敗14,14,1
敗14,14,3
邁14,14,4
夬14,14,9
快14,14,10
嘬14,14,14
䵳14,14,18
咶14,14,19
話14,14,20
牌15,2,3
䁲15,2,4
扠15,2,6
䍲15,2,8
佳15,2,9
𠇗15,2,10
崖15,2,12
釵15,2,14
柴15,2,15
崽15,2,16
娃15,2,18
㗨15,2,19
膎15,2,20
擺15,6,1
罷15,6,3
買15,6,4
廌15,6,7
嬭15,6,8
解15,6,9
𦫼15,6,10
箉15,6,11
矮15,6,18
蟹15,6,20
貝15,9,1
霈15,9,2
旆15,9,3
眜15,9,4
帶15,9,5
太15,9,6
大15,9,7
柰15,9,8
蓋15,9,9
磕15,9,10
艾15,9,12
蔡15,9,14
藹15,9,18
餀15,9,19
害15,9,20
賴15,9,22
㠔15,10,1
懈15,10,9
𡢖15,10,10
睚15,10,12
債15,10,13
差15,10,14
㾹15,10,15
曬15,10,16
隘15,10,18
謑15,10,19
邂15,10,20
蔽15,12,1
潎15,12,2
𡚁15,12,3
袂15,12,4
藝15,12,12
䋵15,12,18
曳15,12,21
媧16,2,9
喎16,2,10
蛙16,2,18
竵16,2,19
鼃16,2,20
𠁥16,6,9
㢊16,6,18
扮16,6,19
夥16,6,20
祋16,9,5
娧16,9,6
兌16,9,7
儈16,9,9
𥢶16,9,10
外16,9,12
最16,9,13
襊16,9,14
蕞16,9,15
𥕸16,9,16
懀16,9,18
𧬨16,9,19
會16,9,20
㦣16,9,21
酹16,9,22
庍16,10,1
派16,10,2
稗16,10,3
賣16,10,4
膪16,10,5
卦16,10,9
瀱16,12,9
蕝16,12,13
膬16,12,14
歲16,12,16
篲16,12,17
銳16,12,21
吞17,1,6
根17,1,9
垠17,1,12
恩17,1,18
痕17,1,20
臻17,2,13
𦿒17,2,15
莘17,2,16
彬17,3,1
貧17,3,3
珉17,3,4
珍17,3,5
𤣆17,3,6
陳17,3,7
紉17,3,8
巾17,3,9
𥎊17,3,11
銀17,3,12
真17,3,13
瞋17,3,14
神17,3,15
申17,3,16
辰17,3,17
𪔗17,3,18
囩17,3,21
鄰17,3,22
人17,3,23
賓17,4,1
繽17,4,2
頻17,4,3
民17,4,4
津17,4,13
親17,4,14
秦17,4,15
辛17,4,16
因17,4,18
礥17,4,20
寅17,4,21
䫀17,5,9
墾17,5,10
𩝗17,5,11
䅰17,5,18
很17,5,20
齔17,6,14
濜17,6,15
䘆17,6,19
愍17,7,4
屒17,7,5
辴17,7,6
紖17,7,7
𢀿17,7,9
螼17,7,10
釿17,7,12
軫17,7,13
矧17,7,16
腎17,7,17
胗17,7,19
隕17,7,21
嶙17,7,22
忍17,7,23
牝17,8,3
泯17,8,4
緊17,8,9
㯸17,8,13
笉17,8,14
盡17,8,15
引17,8,21
艮17,9,9
䭡17,9,18
恨17,9,20
櫬17,10,14
鎮17,11,5
疢17,11,6
陣17,11,7
㧆17,11,9
菣17,11,10
僅17,11,11
憖17,11,12
震17,11,13
眒17,11,16
慎17,11,17
遴17,11,22
刃17,11,23
儐17,12,1
呁17,12,9
螼17,12,10
𣈆17,12,13
親17,12,14
信17,12,16
賮17,12,17
印17,12,18
衅17,12,19
酳17,12,21
𥝬17,13,9
䅱17,13,10
麧17,13,20
櫛17,14,13
𪗨17,14,15
瑟17,14,16
筆17,15,1
弼17,15,3
密17,15,4
窒17,15,5
抶17,15,6
秩17,15,7
暱17,15,8
暨17,15,9
姞17,15,11
耴17,15,12
質17,15,13
叱17,15,14
實17,15,15
失17,15,16
乙17,15,18
肸17,15,19
䫻17,15,21
栗17,15,22
日17,15,23
必17,16,1
匹17,16,2
邲17,16,3
蜜17,16,4
蛭17,16,5
姪17,16,7
昵17,16,8
吉17,16,9
詰17,16,10
佶17,16,11
堲17,16,13
七17,16,14
疾17,16,15
悉17,16,16
一17,16,18
欯17,16,19
逸17,16,21
奔18,1,1
歕18,1,2
盆18,1,3
門18,1,4
敦18,1,5
暾18,1,6
屯18,1,7
黁18,1,8
昆18,1,9
坤18,1,10
㑮18,1,12
尊18,1,13
村18,1,14
存18,1,15
孫18,1,16
温18,1,18
昏18,1,19
䰟18,1,20
論18,1,22
𥖀18,3,2
迍18,3,5
椿18,3,6
䣩18,3,7
麏18,3,9
囷18,3,10
諄18,3,13
春18,3,14
脣18,3,15
媋18,3,16
純18,3,17
贇18,3,18
筠18,3,21
淪18,3,22
犉18,3,23
均18,4,9
憌18,4,11
遵18,4,13
逡18,4,14
鷷18,4,15
荀18,4,16
旬18,4,17
奫18,4,18
勻18,4,21
本18,5,1
翉18,5,2
獖18,5,3
懣18,5,4
畽18,5,6
囤18,5,7
㶧18,5,8
𩩌18,5,9
閫18,5,10
𠟃18,5,13
忖18,5,14
鱒18,5,15
損18,5,16
穩18,5,18
𦃕18,5,19
混18,5,20
𢘵18,5,22
偆18,7,6
稇18,7,10
窘18,7,11
準18,7,13
蠢18,7,14
盾18,7,15
賰18,7,16
耣18,7,22
筍18,8,16
楯18,8,17
尹18,8,21
蝡18,8,23
奔18,9,1
噴18,9,2
坌18,9,3
悶18,9,4
頓18,9,5
鈍18,9,7
嫩18,9,8
睔18,9,9
困18,9,10
顐18,9,12
焌18,9,13
寸18,9,14
鐏18,9,15
巽18,9,16
搵18,9,18
惛18,9,19
慁18,9,20
論18,9,22
稕18,11,13
舜18,11,16
順18,11,17
閏18,11,23
呁18,12,9
雋18,12,13
峻18,12,16
殉18,12,17
䪬18,13,2
勃18,13,3
沒18,13,4
咄18,13,5
宊18,13,6
突18,13,7
訥18,13,8
骨18,13,9
窟18,13,10
兀18,13,12
卒18,13,13
猝18,13,14
捽18,13,15
窣18,13,16
𩑦18,13,18
忽18,13,19
搰18,13,20
𠀽18,13,22
𠭴18,14,13
率18,14,16
㤕18,15,5
黜18,15,6
术18,15,7
屈18,15,11
欪18,15,13
出18,15,14
術18,15,15
律18,15,22
橘18,16,9
卒18,16,13
焌18,16,14
崒18,16,15
恤18,16,16
獝18,16,19
聿18,16,21
斤19,3,9
勤19,3,11
䖐19,3,12
殷19,3,18
欣19,3,19
謹19,7,9
赾19,7,10
近19,7,11
听19,7,12
隱19,7,18
䘆19,7,19
靳19,11,9
近19,11,11
垽19,11,12
㒚19,11,18
焮19,11,19
訖19,15,9
乞19,15,10
䞘19,15,11
疙19,15,12
迄19,15,19
分20,3,1
芬20,3,2
汾20,3,3
文20,3,4
君20,3,9
群20,3,11
熅20,3,18
熏20,3,19
雲20,3,21
粉20,7,1
忿20,7,2
憤20,7,3
吻20,7,4
攟20,7,9
𧼐20,7,10
齳20,7,12
惲20,7,18
抎20,7,21
糞20,11,1
分20,11,3
問20,11,4
攈20,11,9
郡20,11,11
醞20,11,18
訓20,11,19
運20,11,21
弗20,15,1
拂20,15,2
佛20,15,3
物20,15,4
𠀔20,15,9
屈20,15,10
倔20,15,11
崛20,15,12
鬱20,15,18
䬍20,15,19
䬑20,15,21
斒21,2,1
譠21,2,5
𤣆21,2,7
嘫21,2,8
閒21,2,9
慳21,2,10
詽21,2,12
㺗21,2,14
虥21,2,15
山21,2,16
黰21,2,18
羴21,2,19
閑21,2,20
斕21,2,22
犍21,3,9
攑21,3,10
𥴤21,3,11
言21,3,12
蔫21,3,18
軒21,3,19
鞭21,4,1
篇21,4,2
楩21,4,3
綿21,4,4
甄21,4,9
煎21,4,13
遷21,4,14
錢21,4,15
仙21,4,16
涎21,4,17
延21,4,21
版21,6,1
昄21,6,2
阪21,6,3
𥇅21,6,4
簡21,6,9
齦21,6,10
眼21,6,12
醆21,6,13
剗21,6,14
棧21,6,15
產21,6,16
限21,6,20
犍21,7,9
𧥛21,7,10
寋21,7,11
言21,7,12
堰21,7,18
幰21,7,19
褊21,8,1
楩21,8,3
緬21,8,4
蹇21,8,9
遣21,8,10
翦21,8,13
淺21,8,14
踐21,8,15
獮21,8,16
𦆀21,8,17
演21,8,21
扮21,10,1
盻21,10,2
瓣21,10,3
蔄21,10,4
袒21,10,7
襇21,10,9
莧21,10,20
建21,11,9
健21,11,11
堰21,11,18
憲21,11,19
徧21,12,1
騗21,12,2
便21,12,3
面21,12,4
譴21,12,10
巘21,12,12
箭21,12,13
賤21,12,15
線21,12,16
羨21,12,17
衍21,12,21
捌21,14,1
礣21,14,4
哳21,14,5
獺21,14,6
𤷈21,14,8
𪈟21,14,9
楬21,14,10
聐21,14,12
𨰉21,14,13
剎21,14,14
殺21,14,16
𪆰21,14,18
瞎21,14,19
鎋21,14,20
𩭿21,14,23
訐21,15,9
𥴭21,15,10
揭21,15,11
歇21,15,19
鷩21,16,1
瞥21,16,2
蹩21,16,3
滅21,16,4
孑21,16,9
蠽21,16,13
竊21,16,14
薛21,16,16
焆21,16,18
抴21,16,21
列21,16,22
熱21,16,23
窀22,2,7
鰥22,2,9
𡰝22,2,11
頑22,2,12
恮22,2,14
拴22,2,16
𡣬22,2,18
湲22,2,20
𡰠22,2,22
蕃22,3,1
翻22,3,2
煩22,3,3
樠22,3,4
元22,3,12
鴛22,3,18
袁22,3,21
𡰞22,4,5
鐫22,4,13
詮22,4,14
全22,4,15
宣22,4,16
旋22,4,17
娟22,4,18
翾22,4,19
㳂22,4,21
反22,7,1
飯22,7,3
晚22,7,4
卷22,7,9
䅚22,7,10
𧯦22,7,11
阮22,7,12
婉22,7,18
暅22,7,19
遠22,7,21
㜏22,8,11
臇22,8,13
雋22,8,15
選22,8,16
蠉22,8,19
兗22,8,21
輭22,8,23
鰥22,10,9
幻22,10,20
販22,11,1
嬎22,11,2
𩚳22,11,3
万22,11,4
卛22,11,9
券22,11,10
圈22,11,11
願22,11,12
怨22,11,18
楦22,11,19
遠22,11,21
絹22,12,9
選22,12,16
旋22,12,17
掾22,12,21
䫎22,14,5
䫄22,14,6
妠22,14,8
刮22,14,9
刖22,14,12
茁22,14,13
䵵22,14,14
刷22,14,16
頢22,14,20
髮22,15,1
㤄22,15,2
伐22,15,3
韤22,15,4
爡22,15,6
厥22,15,9
闕22,15,10
𦪘22,15,11
月22,15,12
𡡕22,15,18
䬂22,15,19
越22,15,21
缺22,16,10
蕝22,16,13
膬22,16,14
絕22,16,15
雪22,16,16
㿱22,16,17
妜22,16,18
𥄎22,16,19
悅22,16,21
劣22,16,22
單23,1,5
灘23,1,6
壇23,1,7
難23,1,8
干23,1,9
看23,1,10
豻23,1,12
餐23,1,14
殘23,1,15
珊23,1,16
安23,1,18
頇23,1,19
寒23,1,20
蘭23,1,22
姦23,2,9
馯23,2,10
顏23,2,12
潺23,2,15
刪23,2,16
邅23,3,5
脠23,3,6
纏23,3,7
甄23,3,9
愆23,3,10
乾23,3,11
妍23,3,12
饘23,3,13
燀23,3,14
羶23,3,16
鋋23,3,17
焉23,3,18
嘕23,3,19
漹23,3,21
連23,3,22
然23,3,23
邊23,4,1
蹁23,4,3
眠23,4,4
顛23,4,5
天23,4,6
田23,4,7
年23,4,8
堅23,4,9
牽23,4,10
研23,4,12
箋23,4,13
千23,4,14
前23,4,15
先23,4,16
煙23,4,18
祆23,4,19
賢23,4,20
蓮23,4,22
亶23,5,5
坦23,5,6
但23,5,7
攤23,5,8
笴23,5,9
侃23,5,10
䰖23,5,13
瓚23,5,15
繖23,5,16
罕23,5,19
旱23,5,20
嬾23,5,22
赧23,6,8
𪗙23,6,12
䩆23,6,13
㹽23,6,14
𪘪23,6,15
潸23,6,16
辡23,7,1
鴘23,7,2
辨23,7,3
免23,7,4
展23,7,5
搌23,7,6
邅23,7,7
趁23,7,8
蹇23,7,9
件23,7,11
齴23,7,12
𦗢23,7,13
闡23,7,14
㒄23,7,16
善23,7,17
㫃23,7,18
輦23,7,22
蹨23,7,23
編23,8,1
辯23,8,3
典23,8,5
腆23,8,6
殄23,8,7
撚23,8,8
繭23,8,9
𥧬23,8,10
齞23,8,12
戩23,8,13
銑23,8,16
蝘23,8,18
顯23,8,19
峴23,8,20
旦23,9,5
炭23,9,6
憚23,9,7
難23,9,8
旰23,9,9
侃23,9,10
岸23,9,12
贊23,9,13
粲23,9,14
㜺23,9,15
散23,9,16
按23,9,18
漢23,9,19
翰23,9,20
爛23,9,22
㬄23,10,6
諫23,10,9
鴈23,10,12
鏟23,10,14
輚23,10,15
訕23,10,16
晏23,10,18
骭23,10,20
邅23,11,7
輾23,11,8
彥23,11,12
戰23,11,13
硟23,11,14
扇23,11,16
繕23,11,17
躽23,11,18
羨23,11,21
𤹨23,11,22
綖23,11,23
徧23,12,1
片23,12,2
辨23,12,3
麵23,12,4
殿23,12,5
瑱23,12,6
電23,12,7
晛23,12,8
見23,12,9
俔23,12,10
硯23,12,12
薦23,12,13
蒨23,12,14
荐23,12,15
霰23,12,16
宴23,12,18
𩎌23,12,19
見23,12,20
練23,12,22
䔾23,13,4
怛23,13,5
闥23,13,6
達23,13,7
捺23,13,8
葛23,13,9
渴23,13,10
嶭23,13,12
攃23,13,14
巀23,13,15
躠23,13,16
遏23,13,18
䫘23,13,19
曷23,13,20
剌23,13,22
八23,14,1
拔23,14,3
㑻23,14,4
呾23,14,5
薘23,14,7
痆23,14,8
戛23,14,9
𧦼23,14,10
札23,14,13
察23,14,14
殺23,14,16
軋23,14,18
傄23,14,19
黠23,14,20
鼈23,15,1
別23,15,3
哲23,15,5
徹23,15,6
轍23,15,7
揭23,15,9
朅23,15,10
傑23,15,11
孽23,15,12
折23,15,13
掣23,15,14
舌23,15,15
設23,15,16
折23,15,17
焆23,15,18
娎23,15,19
烈23,15,22
熱23,15,23
鷩23,16,1
瞥23,16,2
蹩23,16,3
蔑23,16,4
窒23,16,5
鐵23,16,6
姪23,16,7
涅23,16,8
結23,16,9
揳23,16,10
齧23,16,12
節23,16,13
切23,16,14
𢧵23,16,15
屑23,16,16
噎23,16,18
㚛23,16,19
纈23,16,20
𥸸23,16,22
𤳖24,1,1
潘24,1,2
槃24,1,3
瞞24,1,4
端24,1,5
湍24,1,6
團24,1,7
官24,1,9
寬24,1,10
岏24,1,12
鑽24,1,13
欑24,1,15
酸24,1,16
剜24,1,18
歡24,1,19
桓24,1,20
鑾24,1,22
班24,2,1
攀24,2,2
蠻24,2,4
奻24,2,8
關24,2,9
𤸷24,2,12
跧24,2,13
𤜼24,2,15
彎24,2,18
還24,2,20
勬24,3,9
棬24,3,10
權24,3,11
專24,3,13
穿24,3,14
船24,3,15
遄24,3,17
嬛24,3,19
員24,3,21
攣24,3,22
堧24,3,23
邊24,4,1
涓24,4,9
淵24,4,18
儇24,4,19
玄24,4,20
粄24,5,1
坢24,5,2
伴24,5,3
滿24,5,4
短24,5,5
疃24,5,6
斷24,5,7
暖24,5,8
管24,5,9
款24,5,10
輐24,5,12
纂24,5,13
鄼24,5,15
算24,5,16
椀24,5,18
𤀣24,5,19
緩24,5,20
𡖉24,5,22
版24,6,1
眅24,6,2
阪24,6,3
矕24,6,4
羼24,6,14
撰24,6,15
綰24,6,18
睆24,6,20
轉24,7,5
篆24,7,7
卷24,7,9
圈24,7,11
剸24,7,13
舛24,7,14
膞24,7,16
宛24,7,18
臠24,7,22
腝24,7,23
畎24,8,9
犬24,8,10
旋24,8,16
蜎24,8,18
泫24,8,20
半24,9,1
判24,9,2
叛24,9,3
縵24,9,4
鍛24,9,5
彖24,9,6
段24,9,7
偄24,9,8
貫24,9,9
䥗24,9,10
玩24,9,12
䂎24,9,13
竄24,9,14
攢24,9,15
筭24,9,16
惋24,9,18
喚24,9,19
換24,9,20
亂24,9,22
襻24,10,2
慢24,10,4
奻24,10,8
慣24,10,9
䟒24,10,11
薍24,10,12
篡24,10,14
饌24,10,15
㝈24,10,16
綰24,10,18
患24,10,20
變24,11,1
卞24,11,3
囀24,11,5
猭24,11,6
傳24,11,7
眷24,11,9
䄐24,11,10
倦24,11,11
剸24,11,13
釧24,11,14
𢮨24,11,17
縣24,11,20
瑗24,11,21
戀24,11,22
𤲬24,11,23
睊24,12,9
䬼24,12,18
絢24,12,19
撥24,13,1
潑24,13,2
跋24,13,3
末24,13,4
掇24,13,5
侻24,13,6
奪24,13,7
括24,13,9
闊24,13,10
枂24,13,12
繓24,13,13
撮24,13,14
柮24,13,15
𠞯24,13,16
斡24,13,18
豁24,13,19
活24,13,20
捋24,13,22
八24,14,1
汃24,14,2
拔24,14,3
㑻24,14,4
窡24,14,5
豽24,14,8
劀24,14,9
䯇24,14,10
𦤙24,14,12
茁24,14,13
刷24,14,16
𠋚24,14,19
滑24,14,20
輟24,15,5
𤿫24,15,6
吶24,15,8
蹶24,15,9
拙24,15,13
歠24,15,14
說24,15,16
噦24,15,18
劣24,15,22
𬋖24,15,23
玦24,16,9
闋24,16,10
抉24,16,18
血24,16,19
穴24,16,20
襃25,1,1
㯱25,1,2
袍25,1,3
毛25,1,4
刀25,1,5
饕25,1,6
陶25,1,7
猱25,1,8
高25,1,9
尻25,1,10
敖25,1,12
糟25,1,13
操25,1,14
曹25,1,15
騷25,1,16
䥝25,1,18
蒿25,1,19
豪25,1,20
勞25,1,22
包25,2,1
胞25,2,2
庖25,2,3
茅25,2,4
啁25,2,5
䫸25,2,6
䄻25,2,7
鐃25,2,8
交25,2,9
敲25,2,10
聱25,2,12
𦗔25,2,13
䜈25,2,14
巢25,2,15
梢25,2,16
䫜25,2,18
虓25,2,19
肴25,2,20
顟25,2,22
鑣25,3,1
藨25,3,2
苗25,3,4
朝25,3,5
超25,3,6
晁25,3,7
驕25,3,9
蹻25,3,10
喬25,3,11
堯25,3,12
昭25,3,13
弨25,3,14
燒25,3,16
韶25,3,17
妖25,3,18
囂25,3,19
鴞25,3,21
僚25,3,22
饒25,3,23
貂25,4,5
挑25,4,6
迢25,4,7
驍25,4,9
鄡25,4,10
嶢25,4,12
蕭25,4,16
幺25,4,18
膮25,4,19
聊25,4,22
寶25,5,1
犥25,5,2
抱25,5,3
蓩25,5,4
倒25,5,5
討25,5,6
道25,5,7
腦25,5,8
暠25,5,9
考25,5,10
𦽀25,5,12
早25,5,13
草25,5,14
皁25,5,15
㛮25,5,16
襖25,5,18
好25,5,19
晧25,5,20
老25,5,22
飽25,6,1
鮑25,6,3
卯25,6,4
䝤25,6,5
㺒25,6,8
絞25,6,9
巧25,6,10
齩25,6,12
爪25,6,13
煼25,6,14
䰫25,6,15
拗25,6,18
澩25,6,20
表25,7,1
麃25,7,2
藨25,7,3
巐25,7,6
趙25,7,7
矯25,7,9
𩯘25,7,11
沼25,7,13
𪍑25,7,14
少25,7,16
紹25,7,17
殀25,7,18
繚25,7,22
擾25,7,23
鳥25,8,5
朓25,8,6
窕25,8,7
嬲25,8,8
皎25,8,9
磽25,8,10
湫25,8,13
篠25,8,16
杳25,8,18
曉25,8,19
皛25,8,20
了25,8,22
報25,9,1
暴25,9,3
帽25,9,4
到25,9,5
導25,9,7
腝25,9,8
誥25,9,9
𩝝25,9,10
傲25,9,12
竈25,9,13
操25,9,14
漕25,9,15
喿25,9,16
奧25,9,18
秏25,9,19
號25,9,20
嫪25,9,22
豹25,10,1
奅25,10,2
𦫗25,10,3
𧳖25,10,4
罩25,10,5
趠25,10,6
棹25,10,7
橈25,10,8
教25,10,9
敲25,10,10
樂25,10,12
抓25,10,13
抄25,10,14
巢25,10,15
稍25,10,16
孝25,10,19
效25,10,20
廟25,11,4
脁25,11,6
召25,11,7
驕25,11,9
嶠25,11,11
照25,11,13
少25,11,16
邵25,11,17
療25,11,22
饒25,11,23
弔25,12,5
糶25,12,6
藋25,12,7
尿25,12,8
呌25,12,9
竅25,12,10
顤25,12,12
嘯25,12,16
窔25,12,18
㱇25,12,19
𩕐25,12,22
飆26,4,1
漂26,4,2
瓢26,4,3
蜱26,4,4
蹻26,4,10
翹26,4,11
焦26,4,13
鍫26,4,14
樵26,4,15
霄26,4,16
葽26,4,18
遙26,4,21
褾26,8,1
縹26,8,2
摽26,8,3
眇26,8,4
𥃧26,8,9
剿26,8,13
悄26,8,14
𤃭26,8,15
小26,8,16
闄26,8,18
鷕26,8,21
剽26,12,2
驃26,12,3
妙26,12,4
𧇠26,12,10
翹26,12,11
趬26,12,12
醮26,12,13
陗26,12,14
噍26,12,15
𥬇26,12,16
要26,12,18
燿26,12,21
多27,1,5
他27,1,6
駝27,1,7
那27,1,8
歌27,1,9
珂27,1,10
莪27,1,12
蹉27,1,14
醝27,1,15
娑27,1,16
阿27,1,18
訶27,1,19
何27,1,20
羅27,1,22
癉27,5,5
爹27,5,7
橠27,5,8
哿27,5,9
可27,5,10
我27,5,12
左27,5,13
瑳27,5,14
縒27,5,16
𨵌27,5,18
㰤27,5,19
荷27,5,20
砢27,5,22
跢27,9,5
拖27,9,6
馱27,9,7
奈27,9,8
箇27,9,9
坷27,9,10
餓27,9,12
佐27,9,13
磋27,9,14
些27,9,16
呵27,9,19
賀27,9,20
邏27,9,22
波28,1,1
頗28,1,2
婆28,1,3
摩28,1,4
𨹃28,1,5
詑28,1,6
㸰28,1,7
捼28,1,8
戈28,1,9
科28,1,10
訛28,1,12
侳28,1,13
遳28,1,14
矬28,1,15
莎28,1,16
倭28,1,18
和28,1,20
𩼊28,1,22
𩩆28,3,10
瘸28,3,11
𦚢28,3,18
靴28,3,19
跛28,5,1
叵28,5,2
爸28,5,3
麼28,5,4
朶28,5,5
妥28,5,6
㛂28,5,8
果28,5,9
顆28,5,10
𡜮28,5,12
硰28,5,13
脞28,5,14
坐28,5,15
鎖28,5,16
婐28,5,18
火28,5,19
禍28,5,20
躶28,5,22
播28,9,1
破28,9,2
縛28,9,3
磨28,9,4
桗28,9,5
唾28,9,6
惰28,9,7
愞28,9,8
過28,9,9
課28,9,10
臥28,9,12
挫28,9,13
剉28,9,14
座28,9,15
䐝28,9,16
涴28,9,18
貨28,9,19
和28,9,20
𡰠28,9,22
巴29,2,1
葩29,2,2
爬29,2,3
麻29,2,4
奓29,2,5
侘29,2,6
茶29,2,7
拏29,2,8
嘉29,2,9
䶗29,2,10
牙29,2,12
樝29,2,13
叉29,2,14
楂29,2,15
鯊29,2,16
鵶29,2,18
煆29,2,19
遐29,2,20
遮29,3,13
車29,3,14
蛇29,3,15
奢29,3,16
闍29,3,17
儸29,3,22
若29,3,23
爹29,4,5
嗟29,4,13
㚗29,4,15
些29,4,16
邪29,4,17
耶29,4,21
把29,6,1
跁29,6,3
馬29,6,4
觰29,6,5
奼29,6,6
䋈29,6,8
賈29,6,9
跒29,6,10
雅29,6,12
鮓29,6,13
槎29,6,15
灑29,6,16
啞29,6,18
㗿29,6,19
下29,6,20
䖃29,6,22
者29,7,13
捨29,7,16
社29,7,17
若29,7,23
姐29,8,13
且29,8,14
抯29,8,15
寫29,8,16
灺29,8,17
野29,8,21
霸29,10,1
怕29,10,2
𥝧29,10,3
禡29,10,4
吒29,10,5
詫29,10,6
䖳29,10,7
䏧29,10,8
駕29,10,9
髂29,10,10
迓29,10,12
詐29,10,13
乍29,10,15
嗄29,10,16
亞29,10,18
嚇29,10,19
暇29,10,20
柘29,11,13
䞣29,11,14
射29,11,15
舍29,11,16
偌29,11,23
㰤29,12,10
唶29,12,13
笡29,12,14
褯29,12,15
蝑29,12,16
謝29,12,17
夜29,12,21
檛30,2,5
瓜30,2,9
誇30,2,10
𣢉30,2,12
髽30,2,13
窊30,2,18
花30,2,19
華30,2,20
觰30,6,5
寡30,6,9
髁30,6,10
瓦30,6,12
𡎬30,6,13
䂳30,6,14
葰30,6,15
搲30,6,18
踝30,6,20
坬30,10,9
跨30,10,10
瓦30,10,12
誜30,10,16
攨30,10,18
化30,10,19
㕦30,10,20
幫31,1,1
滂31,1,2
傍31,1,3
茫31,1,4
當31,1,5
湯31,1,6
唐31,1,7
囊31,1,8
剛31,1,9
穅31,1,10
卬31,1,12
臧31,1,13
倉31,1,14
藏31,1,15
桑31,1,16
鴦31,1,18
忼31,1,19
航31,1,20
郎31,1,22
莊31,2,13
瘡31,2,14
牀31,2,15
霜31,2,16
方31,3,1
芳31,3,2
房31,3,3
亡31,3,4
張31,3,5
倀31,3,6
長31,3,7
孃31,3,8
薑31,3,9
羌31,3,10
強31,3,11
章31,3,13
昌31,3,14
啇31,3,16
常31,3,17
央31,3,18
香31,3,19
羊31,3,21
良31,3,22
穰31,3,23
將31,4,13
鏘31,4,14
牆31,4,15
相31,4,16
詳31,4,17
陽31,4,21
榜31,5,1
髈31,5,2
莽31,5,4
黨31,5,5
儻31,5,6
蕩31,5,7
曩31,5,8
䴚31,5,9
慷31,5,10
䭹31,5,12
駔31,5,13
蒼31,5,14
顙31,5,16
坱31,5,18
汻31,5,19
沆31,5,20
朗31,5,22
磢31,6,14
𤕤31,6,16
昉31,7,1
髣31,7,2
罔31,7,4
長31,7,5
昶31,7,6
丈31,7,7
繈31,7,9
勥31,7,11
仰31,7,12
掌31,7,13
敞31,7,14
賞31,7,16
上31,7,17
鞅31,7,18
響31,7,19
兩31,7,22
壤31,7,23
獎31,8,13
搶31,8,14
想31,8,16
像31,8,17
養31,8,21
螃31,9,1
傍31,9,3
漭31,9,4
譡31,9,5
儻31,9,6
宕31,9,7
儾31,9,8
鋼31,9,9
抗31,9,10
枊31,9,12
葬31,9,13
䅮31,9,14
藏31,9,15
䘮31,9,16
盎31,9,18
吭31,9,20
浪31,9,22
壯31,10,13
刱31,10,14
狀31,10,15
放31,11,1
訪31,11,2
防31,11,3
妄31,11,4
帳31,11,5
暢31,11,6
仗31,11,7
釀31,11,8
殭31,11,9
唴31,11,10
強31,11,11
𨋕31,11,12
障31,11,13
唱31,11,14
餉31,11,16
尚31,11,17
怏31,11,18
向31,11,19
亮31,11,22
讓31,11,23
醬31,12,13
蹡31,12,14
匠31,12,15
相31,12,16
漾31,12,21
博31,13,1
𩔈31,13,2
泊31,13,3
莫31,13,4
託31,13,6
鐸31,13,7
諾31,13,8
各31,13,9
恪31,13,10
愕31,13,12
作31,13,13
錯31,13,14
昨31,13,15
索31,13,16
惡31,13,18
臛31,13,19
涸31,13,20
落31,13,22
斮31,14,13
𩌏31,15,1
𩅿31,15,2
縛31,15,3
芍31,15,5
辵31,15,6
著31,15,7
逽31,15,8
腳31,15,9
卻31,15,10
噱31,15,11
虐31,15,12
灼31,15,13
綽31,15,14
鑠31,15,16
杓31,15,17
約31,15,18
謔31,15,19
略31,15,22
弱31,15,23
爵31,16,13
鵲31,16,14
嚼31,16,15
削31,16,16
藥31,16,21
光32,1,9
䯑32,1,10
汪32,1,18
荒32,1,19
黃32,1,20
匡32,3,10
狂32,3,11
王32,3,21
廣32,5,9
懬32,5,10
㳹32,5,18
慌32,5,19
晃32,5,20
俇32,6,11
枉32,7,18
怳32,7,19
往32,7,21
桄32,9,9
曠32,9,10
汪32,9,18
荒32,9,19
潢32,9,20
誑32,11,11
況32,11,19
旺32,11,21
郭32,13,9
廓32,13,10
瓁32,13,12
艧32,13,18
霍32,13,19
檴32,13,20
玃32,15,9
躩32,15,10
戄32,15,11
嬳32,15,18
䂄32,15,19
籰32,15,21
閍33,2,1
磅33,2,2
彭33,2,3
盲33,2,4
趟33,2,5
瞠33,2,6
棖33,2,7
儜33,2,8
庚33,2,9
坑33,2,10
鎗33,2,14
傖33,2,15
生33,2,16
亨33,2,19
行33,2,20
兵33,3,1
平33,3,3
明33,3,4
京33,3,9
𡖥33,3,10
擎33,3,11
英33,3,18
并33,4,1
名33,4,4
輕33,4,10
頸33,4,11
迎33,4,12
精33,4,13
清33,4,14
情33,4,15
騂33,4,16
𩛿33,4,17
嬰33,4,18
盈33,4,21
浜33,6,1
鮩33,6,3
猛33,6,4
盯33,6,5
瑒33,6,7
檸33,6,8
梗33,6,9
省33,6,16
䁝33,6,18
杏33,6,20
冷33,6,22
丙33,7,1
皿33,7,4
警33,7,9
影33,7,18
餅33,8,1
眳33,8,4
頸33,8,9
井33,8,13
請33,8,14
靜33,8,15
省33,8,16
癭33,8,18
榜33,10,1
烹33,10,2
膨33,10,3
孟33,10,4
倀33,10,5
牚33,10,6
鋥33,10,7
更33,10,9
硬33,10,12
行33,10,20
柄33,11,1
病33,11,3
命33,11,4
敬33,11,9
慶33,11,10
競33,11,11
迎33,11,12
映33,11,18
拼33,12,1
聘33,12,2
偋33,12,3
詺33,12,4
勁33,12,9
精33,12,13
倩33,12,14
淨33,12,15
性33,12,16
伯33,14,1
拍33,14,2
白33,14,3
陌33,14,4
磔33,14,5
坼33,14,6
宅33,14,7
蹃33,14,8
格33,14,9
客33,14,10
額33,14,12
迮33,14,13
柵33,14,14
齚33,14,15
索33,14,16
啞33,14,18
赫33,14,19
垎33,14,20
礐33,14,22
欂33,15,3
𪐏33,15,5
戟33,15,9
隙33,15,10
劇33,15,11
逆33,15,12
辟33,16,1
僻33,16,2
擗33,16,3
剔33,16,6
積33,16,13
剌33,16,14
籍33,16,15
昔33,16,16
席33,16,17
益33,16,18
繹33,16,21
觥34,2,9
諻34,2,19
橫34,2,20
兄34,3,19
營34,3,21
傾34,4,10
瓊34,4,11
觪34,4,16
縈34,4,18
𧵣34,4,19
榮34,4,21
礦34,6,9
𥉁34,6,10
卝34,6,20
璟34,7,9
憬34,7,10
𦬺34,7,19
永34,7,21
頃34,8,10
潁34,8,21
𥥈34,10,18
蝗34,10,20
詠34,11,21
敻34,12,19
虢34,14,9
擭34,14,18
砉34,14,19
嚄34,14,20
䪝34,15,18
鶪34,16,9
䠐34,16,10
𦳮34,16,13
𥄎34,16,14
瞁34,16,19
役34,16,21
絣35,2,1
怦35,2,2
棚35,2,3
甍35,2,4
朾35,2,5
撑35,2,6
橙35,2,7
儜35,2,8
耕35,2,9
鏗35,2,10
娙35,2,12
爭35,2,13
琤35,2,14
崢35,2,15
罌35,2,18
莖35,2,20
征35,3,13
聲35,3,16
成35,3,17
跉35,3,22
竮35,4,2
瓶35,4,3
冥35,4,4
丁35,4,5
汀35,4,6
庭35,4,7
寧35,4,8
經35,4,9
輕35,4,10
菁35,4,13
青35,4,14
星35,4,16
馨35,4,19
刑35,4,20
靈35,4,22
皏35,6,2
𠊧35,6,3
䁅35,6,4
耿35,6,9
幸35,6,20
逞35,7,6
頸35,7,9
痙35,7,11
整35,7,13
領35,7,22
鞞35,8,1
頩35,8,2
並35,8,3
茗35,8,4
頂35,8,5
侹35,8,6
挺35,8,7
𩕳35,8,8
剄35,8,9
䀴35,8,12
汫35,8,15
醒35,8,16
巊35,8,18
婞35,8,20
笭35,8,22
迸35,10,1
𠊧35,10,3
硬35,10,12
諍35,10,13
䙬35,10,18
遉35,11,6
鄭35,11,7
政35,11,13
聖35,11,16
盛35,11,17
令35,11,22
跰35,12,1
䒌35,12,4
矴35,12,5
聽35,12,6
定35,12,7
甯35,12,8
俓35,12,9
罄35,12,10
靘35,12,14
腥35,12,16
脛35,12,20
零35,12,22
檗35,14,1
𢶉35,14,2
䌟35,14,3
麥35,14,4
摘35,14,5
隔35,14,9
礊35,14,10
虉35,14,12
責35,14,13
策35,14,14
賾35,14,15
栜35,14,16
戹35,14,18
覈35,14,20
碧35,15,1
𪐏35,15,5
擲35,15,7
隻35,15,13
尺35,15,14
射35,15,15
釋35,15,16
石35,15,17
㔏35,15,22
璧35,16,1
劈35,16,2
甓35,16,3
覓35,16,4
的35,16,5
逖35,16,6
狄35,16,7
惄35,16,8
激35,16,9
燩35,16,10
鷁35,16,12
績35,16,13
戚35,16,14
寂35,16,15
錫35,16,16
赥35,16,19
檄35,16,20
靂35,16,22
繃36,2,1
泓36,2,18
轟36,2,19
宏36,2,20
扃36,4,9
熒36,4,20
熲36,8,9
褧36,8,10
濙36,8,18
詗36,8,19
迥36,8,20
𥥈36,10,18
轟36,10,19
鎣36,12,18
詗36,12,19
蟈36,14,9
𥕏36,14,10
䟒36,14,11
㩇36,14,13
䞰36,14,15
𢷾36,14,16
劃36,14,19
獲36,14,20
礰36,14,22
𣤩36,16,6
郹36,16,9
闃36,16,10
殈36,16,19
裒37,1,3
呣37,1,4
𫥢37,1,5
偷37,1,6
頭37,1,7
羺37,1,8
鉤37,1,9
彄37,1,10
齵37,1,12
𣠏37,1,13
䜅37,1,14
㔌37,1,15
涑37,1,16
謳37,1,18
齁37,1,19
侯37,1,20
樓37,1,22
鄒37,2,13
搊37,2,14
愁37,2,15
搜37,2,16
不37,3,1
浮37,3,3
謀37,3,4
輈37,3,5
抽37,3,6
儔37,3,7
鳩37,3,9
丘37,3,10
求37,3,11
牛37,3,12
周37,3,13
犫37,3,14
收37,3,16
讎37,3,17
優37,3,18
休37,3,19
尤37,3,21
劉37,3,22
柔37,3,23
彪37,4,1
䬌37,4,2
滮37,4,3
繆37,4,4
樛37,4,9
恘37,4,10
聱37,4,12
啾37,4,13
秋37,4,14
遒37,4,15
脩37,4,16
囚37,4,17
幽37,4,18
飍37,4,19
由37,4,21
鏐37,4,22
掊37,5,1
剖37,5,2
部37,5,3
母37,5,4
斗37,5,5
黈37,5,6
䕆37,5,7
㝅37,5,8
苟37,5,9
口37,5,10
藕37,5,12
走37,5,13
趣37,5,14
鯫37,5,15
叟37,5,16
歐37,5,18
吼37,5,19
厚37,5,20
塿37,5,22
掫37,6,13
𩋄37,6,14
𥣙37,6,15
湊37,6,16
缶37,7,1
紑37,7,2
婦37,7,3
肘37,7,5
丑37,7,6
紂37,7,7
狃37,7,8
久37,7,9
糗37,7,10
臼37,7,11
帚37,7,13
醜37,7,14
壽37,7,15
首37,7,16
受37,7,17
䬀37,7,18
朽37,7,19
有37,7,21
柳37,7,22
蹂37,7,23
糾37,8,9
蟉37,8,11
酒37,8,13
湫37,8,15
滫37,8,16
黝37,8,18
酉37,8,21
仆37,9,2
䏽37,9,3
茂37,9,4
鬭37,9,5
透37,9,6
豆37,9,7
耨37,9,8
遘37,9,9
寇37,9,10
偶37,9,12
奏37,9,13
輳37,9,14
㔌37,9,15
瘶37,9,16
漚37,9,18
詬37,9,19
候37,9,20
陋37,9,22
皺37,10,13
簉37,10,14
驟37,10,15
瘦37,10,16
富37,11,1
副37,11,2
復37,11,3
莓37,11,4
晝37,11,5
胄37,11,7
糅37,11,8
救37,11,9
𪖛37,11,10
𪖐37,11,12
咒37,11,13
臭37,11,14
狩37,11,16
授37,11,17
齅37,11,19
宥37,11,21
溜37,11,22
輮37,11,23
謬37,12,4
䠗37,12,10
𧾻37,12,11
僦37,12,13
䞭37,12,14
就37,12,15
秀37,12,16
岫37,12,17
幼37,12,18
狖37,12,21
簪38,2,13
嵾38,2,14
岑38,2,15
森38,2,16
碪38,3,5
琛38,3,6
沈38,3,7
䛘38,3,8
金38,3,9
欽38,3,10
琴38,3,11
吟38,3,12
斟38,3,13
𧡪38,3,14
忱38,3,15
深38,3,16
諶38,3,17
音38,3,18
歆38,3,19
林38,3,22
任38,3,23
舚38,4,6
祲38,4,13
侵38,4,14
𩷒38,4,15
心38,4,16
尋38,4,17
愔38,4,18
淫38,4,21
䫬38,6,13
墋38,6,14
𩒣38,6,15
㾕38,6,16
稟38,7,1
品38,7,2
戡38,7,5
踸38,7,6
朕38,7,7
拰38,7,8
錦38,7,9
坅38,7,10
噤38,7,11
僸38,7,12
枕38,7,13
瀋38,7,14
葚38,7,15
沈38,7,16
甚38,7,17
飲38,7,18
廞38,7,19
廩38,7,22
荏38,7,23
𩖄38,8,10
䤐38,8,13
寢38,8,14
蕈38,8,15
罧38,8,16
譖38,10,13
讖38,10,14
滲38,10,16
揕38,11,5
闖38,11,6
鴆38,11,7
賃38,11,8
禁38,11,9
𦧈38,11,11
吟38,11,12
枕38,11,13
深38,11,16
甚38,11,17
蔭38,11,18
䫴38,11,21
臨38,11,22
絍38,11,23
浸38,12,13
沁38,12,14
戢38,14,13
㞚38,14,14
霵38,14,15
澀38,14,16
鵖38,15,1
𩾳38,15,3
縶38,15,5
湁38,15,6
蟄38,15,7
孨38,15,8
急38,15,9
泣38,15,10
及38,15,11
岌38,15,12
執38,15,13
斟38,15,14
褶38,15,15
溼38,15,16
十38,15,17
邑38,15,18
吸38,15,19
煜38,15,21
立38,15,22
入38,15,23
㗱38,16,13
緝38,16,14
集38,16,15
𩎕38,16,16
習38,16,17
揖38,16,18
熠38,16,21
耽39,1,5
探39,1,6
覃39,1,7
南39,1,8
弇39,1,9
龕39,1,10
䜙39,1,12
簪39,1,13
參39,1,14
蠶39,1,15
毿39,1,16
諳39,1,18
㟏39,1,19
含39,1,20
婪39,1,22
詀39,2,5
諵39,2,8
緘39,2,9
鵮39,2,10
嵒39,2,12
讒39,2,15
攕39,2,16
𤟟39,2,18
㰹39,2,19
咸39,2,20
砭39,3,1
霑39,3,5
覘39,3,6
㶣39,3,7
黏39,3,8
廉39,3,9
𪙊39,3,12
詹39,3,13
䄡39,3,14
苫39,3,16
棎39,3,17
淹39,3,18
𡝫39,3,19
炎39,3,21
廉39,3,22
髯39,3,23
𩬑39,4,5
添39,4,6
甜39,4,7
鮎39,4,8
謙39,4,10
鉗39,4,11
尖39,4,13
馦39,4,19
嫌39,4,20
鬑39,4,22
黕39,5,5
襑39,5,6
禫39,5,7
腩39,5,8
感39,5,9
坎39,5,10
頷39,5,12
寁39,5,13
慘39,5,14
歜39,5,15
糂39,5,16
晻39,5,18
䫲39,5,19
頷39,5,20
𡒄39,5,22
𠐩39,6,6
湛39,6,7
𦊔39,6,8
鹼39,6,9
㦿39,6,10
䫡39,6,12
斬39,6,13
䑎39,6,14
瀺39,6,15
摻39,6,16
黯39,6,18
喊39,6,19
豏39,6,20
臉39,6,22
貶39,7,1
諂39,7,6
檢39,7,9
𩑳39,7,10
儉39,7,11
顩39,7,12
颭39,7,13
陝39,7,16
剡39,7,17
奄39,7,18
險39,7,19
鼸39,7,20
斂39,7,22
冉39,7,23
𡕢39,8,4
點39,8,5
忝39,8,6
簟39,8,7
淰39,8,8
孂39,8,9
歉39,8,10
憯39,8,14
稴39,8,22
苒39,8,23
馾39,9,5
僋39,9,6
醰39,9,7
妠39,9,8
紺39,9,9
勘39,9,10
儑39,9,12
篸39,9,13
謲39,9,14
㨻39,9,15
俕39,9,16
暗39,9,18
䫲39,9,19
憾39,9,20
顲39,9,22
𪉜39,10,5
𧸖39,10,7
諵39,10,8
𪉦39,10,9
歉39,10,10
顑39,10,12
蘸39,10,13
闞39,10,19
陷39,10,20
窆39,11,1
覘39,11,6
驗39,11,12
占39,11,13
䠨39,11,14
閃39,11,16
贍39,11,17
𢜰39,11,18
殮39,11,22
染39,11,23
店39,12,5
㮇39,12,6
磹39,12,7
念39,12,8
趝39,12,9
傔39,12,10
僭39,12,13
䁮39,12,15
䃸39,12,16
酓39,12,18
稴39,12,22
答39,13,5
錔39,13,6
沓39,13,7
納39,13,8
閤39,13,9
溘39,13,10
𣊡39,13,12
帀39,13,13
䟃39,13,14
雜39,13,15
趿39,13,16
姶39,13,18
欱39,13,19
合39,13,20
拉39,13,22
劄39,14,5
𥃐39,14,6
㘝39,14,8
夾39,14,9
恰39,14,10
䀴39,14,12
貶39,14,13
插39,14,14
𨖷39,14,15
霎39,14,16
𨂁39,14,18
䶎39,14,19
洽39,14,20
輒39,15,5
鍤39,15,6
䐑39,15,7
聶39,15,8
𦀖39,15,9
㾜39,15,10
笈39,15,11
讋39,15,13
謵39,15,14
攝39,15,16
涉39,15,17
𢽱39,15,18
偞39,15,19
瞱39,15,21
獵39,15,22
讘39,15,23
聑39,16,5
怗39,16,6
牒39,16,7
捻39,16,8
頰39,16,9
愜39,16,10
浹39,16,13
妾39,16,14
䕹39,16,15
燮39,16,16
㛍39,16,19
協39,16,20
姏40,1,4
擔40,1,5
舑40,1,6
談40,1,7
甘40,1,9
坩40,1,10
慙40,1,15
三40,1,16
黯40,1,18
蚶40,1,19
酣40,1,20
藍40,1,22
𨂝40,2,3
監40,2,9
嵌40,2,10
巖40,2,12
攙40,2,14
巉40,2,15
衫40,2,16
銜40,2,20
㪁40,3,10
黔40,3,11
嚴40,3,12
𥰨40,3,17
醃40,3,18
𩏩40,3,19
䇝40,4,13
籤40,4,14
潛40,4,15
銛40,4,16
燖40,4,17
懕40,4,18
鹽40,4,21
㛧40,5,4
膽40,5,5
菼40,5,6
噉40,5,7
敢40,5,9
𠪚40,5,10
䭕40,5,13
黲40,5,14
槧40,5,15
埯40,5,18
喊40,5,19
覽40,5,22
䫡40,6,10
醶40,6,14
㨻40,6,16
黤40,6,18
㺖40,6,19
檻40,6,20
儼40,7,12
㴸40,7,16
埯40,7,18
憸40,8,14
漸40,8,15
黶40,8,18
琰40,8,21
擔40,9,5
賧40,9,6
擔40,9,7
𪉦40,9,9
闞40,9,10
暫40,9,15
三40,9,16
𧵊40,9,19
憨40,9,20
濫40,9,22
埿40,10,3
鑑40,10,9
覱40,10,13
懺40,10,14
鑱40,10,15
釤40,10,16
𪒠40,10,18
㒈40,10,19
㽉40,10,20
㪁40,11,10
釅40,11,12
䝱40,11,19
獫40,11,22
驗40,12,12
𡄑40,12,13
壍40,12,14
潛40,12,15
厭40,12,18
豔40,12,21
殮40,12,22
染40,12,23
㿴40,13,5
榻40,13,6
踏40,13,7
魶40,13,8
䫦40,13,9
榼40,13,10
儑40,13,12
囃40,13,14
䪞40,13,15
𠎷40,13,16
鰪40,13,18
𣣹40,13,19
盍40,13,20
臘40,13,22
渫40,14,7
甲40,14,9
翣40,14,16
鴨40,14,18
呷40,14,19
狎40,14,20
㙷40,15,7
劫40,15,9
怯40,15,10
跲40,15,11
業40,15,12
䢡40,15,16
腌40,15,18
脅40,15,19
殜40,15,21
接40,16,13
妾40,16,14
捷40,16,15
魘40,16,18
挾40,16,20
葉40,16,21
𧦟41,3,1
䒦41,3,2
凡41,3,3
𦜒41,7,1
釩41,7,2
范41,7,3
錽41,7,4
𠑆41,7,6
拑41,7,9
凵41,7,10
顩41,7,12
汎41,11,2
梵41,11,3
𦲯41,11,4
劒41,11,9
欠41,11,10
法41,15,1
𥎰41,15,2
乏41,15,3
𦑣41,15,5
䎎41,15,8
猲41,15,10
崩42,1,1
漰42,1,2
朋42,1,3
瞢42,1,4
登42,1,5
鼟42,1,6
騰42,1,7
能42,1,8
緪42,1,9
增42,1,13
層42,1,15
僧42,1,16
恆42,1,20
楞42,1,22
冰42,3,1
砯42,3,2
凭42,3,3
徵42,3,5
僜42,3,6
澄42,3,7
兢42,3,9
硱42,3,10
殑42,3,11
凝42,3,12
蒸42,3,13
稱42,3,14
繩42,3,15
升42,3,16
承42,3,17
膺42,3,18
興42,3,19
蠅42,3,21
陵42,3,22
仍42,3,23
繒42,4,15
倗42,5,2
𨹹42,5,3
等42,5,5
能42,5,8
肯42,5,10
㽪42,5,13
倰42,5,22
庱42,7,6
殑42,7,11
拯42,7,13
㱡42,7,16
𥦜42,9,1
倗42,9,3
𢅴42,9,4
嶝42,9,5
𤃶42,9,6
鄧42,9,7
亙42,9,9
增42,9,13
蹭42,9,14
贈42,9,15
𡬙42,9,16
凭42,11,3
覴42,11,6
瞪42,11,7
殑42,11,11
凝42,11,12
證42,11,13
稱42,11,14
乘42,11,15
勝42,11,16
剩42,11,17
應42,11,18
興42,11,19
孕42,11,21
𩜁42,11,22
認42,11,23
甑42,12,13
㣒42,12,14
北42,13,1
菔42,13,3
墨42,13,4
德42,13,5
忒42,13,6
特42,13,7
䘅42,13,8
裓42,13,9
刻42,13,10
則42,13,13
墄42,13,14
賊42,13,15
塞42,13,16
餩42,13,18
黑42,13,19
劾42,13,20
勒42,13,22
稄42,14,13
測42,14,14
崱42,14,15
色42,14,16
逼42,15,1
堛42,15,2
愎42,15,3
䁇42,15,4
陟42,15,5
敕42,15,6
直42,15,7
匿42,15,8
殛42,15,9
䩯42,15,10
極42,15,11
嶷42,15,12
職42,15,13
瀷42,15,14
食42,15,15
識42,15,16
寔42,15,17
憶42,15,18
赩42,15,19
力42,15,22
𡮞42,16,5
即42,16,13
堲42,16,15
息42,16,16
弋42,16,21
肱43,1,9
泓43,1,18
薨43,1,19
弘43,1,20
國43,13,9
或43,13,20
洫43,15,19
域43,15,21`.split('\n');

export default 韻鏡資料;
